import { Box, HStack, Text, useColorModeValue } from '@elkaso-app/web-design';
import { IPriceBenchmark } from '../utils/types';

interface PriceBenchmarkSectionProps {
  benchmark: IPriceBenchmark;
}

export const PriceBenchmarkSection = ({ benchmark }: PriceBenchmarkSectionProps) => {
  const min = benchmark.min ?? 0;
  const max = benchmark.max ?? 0;
  const avg = benchmark.avg ?? 0;
  const currentSupplierPrice = benchmark.currentSupplierPrice ?? 0;
  const percentVsAvg = benchmark.percentVsAvg ?? 0;
  const range = max - min || 1;
  const currentPosition = ((currentSupplierPrice - min) / range) * 100;
  const avgPosition = ((avg - min) / range) * 100;
  const barBg = useColorModeValue('gray.200', 'gray.600');

  const percentColor = percentVsAvg > 5 ? 'red.500' : percentVsAvg < -5 ? 'green.500' : 'gray.600';
  const percentLabel =
    percentVsAvg > 0 ? `+${percentVsAvg.toFixed(1)}% above avg` : `${percentVsAvg.toFixed(1)}% below avg`;

  return (
    <Box>
      <HStack justify='space-between' mb={4}>
        <Box textAlign='center'>
          <Text fontSize='xs' color='gray.500'>
            Min
          </Text>
          <Text fontSize='lg' fontWeight='bold'>
            {min.toFixed(2)}
          </Text>
        </Box>
        <Box textAlign='center'>
          <Text fontSize='xs' color='gray.500'>
            Market Avg
          </Text>
          <Text fontSize='lg' fontWeight='bold'>
            {avg.toFixed(2)}
          </Text>
        </Box>
        <Box textAlign='center'>
          <Text fontSize='xs' color='gray.500'>
            Max
          </Text>
          <Text fontSize='lg' fontWeight='bold'>
            {max.toFixed(2)}
          </Text>
        </Box>
      </HStack>

      <Box position='relative' h='32px' bg={barBg} borderRadius='full' mb={2}>
        <Box position='absolute' left={`${avgPosition}%`} top='0' bottom='0' w='2px' bg='gray.500' zIndex={1} />
        <Box
          position='absolute'
          left={`${Math.min(Math.max(currentPosition, 2), 98)}%`}
          top='50%'
          transform='translate(-50%, -50%)'
          w='16px'
          h='16px'
          borderRadius='full'
          bg='blue.500'
          border='3px solid white'
          boxShadow='md'
          zIndex={2}
        />
      </Box>

      <HStack justify='space-between'>
        <Text fontSize='sm' color='gray.600'>
          Current:{' '}
          <Text as='span' fontWeight='bold'>
            AED {currentSupplierPrice.toFixed(2)}
          </Text>
        </Text>
        <Text fontSize='sm' fontWeight='bold' color={percentColor}>
          {percentLabel}
        </Text>
      </HStack>
    </Box>
  );
};
